import { RECEIVE_PARTIDAS, REQUEST_PARTIDAS } from "../actions/partidas";

const partidasReducer = (state = {}, action) => {
  switch (action.type) {
    case REQUEST_PARTIDAS:
      return (state = { ...state, isFetching: true });
      break;
    case RECEIVE_PARTIDAS:
      return (state = {
        ...state,
        isFetching: false,
        partidas: action.partidas,
        lastUpdate: action.receivedAt
      });
      break;

    default:
      return state;
  }
};

export default partidasReducer;
